export const invalidConnection = [
  {
    'source': 'RO',
    'sourcePort': 'Product',
    'Destination': 'Waste',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    'Msg': 'The attempted stream connection is currently not supported (ref: 2a). Pease contact Veolia for assistance.'
  }, {
    'source': 'RO',
    'sourcePort': 'Waste',
    'Destination': 'EDI',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    'Msg': 'The attempted stream connection is currently not supported (ref: 1b). Pease contact Veolia for assistance.'
  }, {
    'source': 'RO',
    'sourcePort': 'Waste',
    'Destination': 'ProductOut',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    'Msg': 'The attempted stream connection is currently not supported (ref: 1c). Pease contact Veolia for assistance.'
  }, {
    'source': 'RO_HP',
    'sourcePort': 'Product',
    'Destination': 'Waste',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    'Msg': 'The attempted stream connection is currently not supported (ref: 2a). Pease contact Veolia for assistance.'
  }, {
    'source': 'RO_HP',
    'sourcePort': 'Waste',
    'Destination': 'EDI',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    'Msg': 'The attempted stream connection is currently not supported (ref: 2b). Pease contact Veolia for assistance.'
  }, {
    'source': 'RO_HP',
    'sourcePort': 'Waste',
    'Destination': 'ProductOut',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    'Msg': 'The attempted stream connection is currently not supported (ref: 2c). Pease contact Veolia for assistance.'
  }, {
    'source': 'EDI',
    'sourcePort': 'Product',
    'Destination': 'RO',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    // 'Msg': 'Current RO model is not applicable to high resistivity EDI product stream'
    'Msg': 'The attempted stream connection is currently not supported (ref: 3a). Pease contact Veolia for assistance.'
  }, {
    'source': 'EDI',
    'sourcePort': 'Product',
    'Destination': 'RO_HP',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    // 'Msg': 'Current RO model is not applicable to high resistivity EDI product stream'
    'Msg': 'The attempted stream connection is currently not supported (ref: 3b). Pease contact Veolia for assistance.'
  }, {
    'source': 'EDI',
    'sourcePort': 'Product',
    'Destination': 'Stripper',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    'Msg': 'The attempted stream connection is currently not supported (ref: 3c). Pease contact Veolia for assistance.'
  }, {
    'source': 'EDI',
    'sourcePort': 'Product',
    'Destination': 'EDI',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': 'invalid',
    // 'Msg': 'EDI cascade violation, but this can be part of future NPI\\NTI program though'
    'Msg': 'The attempted stream connection is currently not supported (ref: 3d). Pease contact Veolia for assistance.'
  }, {
    'source': 'EDI',
    'sourcePort': 'Product',
    'Destination': 'Waste',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': 'invalid',
    'Msg': 'The attempted stream connection is currently not supported (ref: 3e). Pease contact Veolia for assistance.'
  }, {
    'source': 'EDI',
    'sourcePort': 'Concentrate Bleed',
    'Destination': 'EDI',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    // 'Msg': 'EDI cascade violation'
    'Msg': 'The attempted stream connection is currently not supported (ref: 3f). Pease contact Veolia for assistance.'
  }, {
    'source': 'EDI',
    'sourcePort': 'Concentrate Bleed',
    'Destination': 'ProductOut',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    'Msg': 'The attempted stream connection is currently not supported (ref: 3g). Pease contact Veolia for assistance.'
  }, {
    'source': 'EDI',
    'sourcePort': 'Electrode Bleed',
    'Destination': 'EDI',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    'Msg': 'The attempted stream connection is currently not supported (ref: 3h). Pease contact Veolia for assistance.'
  }, {
    'source': 'EDI',
    'sourcePort': 'Electrode Bleed',
    'Destination': 'ProductOut',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    'Msg': 'The attempted stream connection is currently not supported (ref: 3i). Pease contact Veolia for assistance.'
  },
  {
    'source': 'Chemical_Dosing',
    'sourcePort': 'Product',
    'Destination': 'EDI',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    'Msg': 'The attempted stream connection is currently not supported (ref: 4a). Pease contact Veolia for assistance.'
  },
  {
    'source': 'Chemical_Dosing',
    'sourcePort': 'Product',
    'Destination': 'NF',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    'Msg': 'The attempted stream connection is currently not supported (ref: 4b). Pease contact Veolia for assistance.'
  },
  {
    'source': 'Chemical_Dosing',
    'sourcePort': 'Product',
    'Destination': 'NF_HP',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    'Msg': 'The attempted stream connection is currently not supported (ref: 4c). Pease contact Veolia for assistance.'
  },
  {
    'source': 'Stripper',
    'sourcePort': 'Product',
    'Destination': 'Stripper',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    // 'Msg': 'Redundant'
    'Msg': 'The attempted stream connection is currently not supported (ref: 5a). Pease contact Veolia for assistance.'
  },
  {
    'source': 'Stripper',
    'sourcePort': 'Product',
    'Destination': 'NF',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    // 'Msg': 'Redundant'
    'Msg': 'The attempted stream connection is currently not supported (ref: 5b). Pease contact Veolia for assistance.'
  },
  {
    'source': 'Stripper',
    'sourcePort': 'Product',
    'Destination': 'NF_HP',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    // 'Msg': 'Redundant'
    'Msg': 'The attempted stream connection is currently not supported (ref: 5c). Pease contact Veolia for assistance.'
  },
  {
    'source': 'Feed',
    'sourcePort': 'Product',
    'Destination': 'ProductOut',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    // 'Msg': 'No separation or unit operation in between'
    'Msg': 'The attempted stream connection is currently not supported (ref: 6a). Pease contact Veolia for assistance.'
  }, {
    'source': 'Feed',
    'sourcePort': 'Product',
    'Destination': 'Waste',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    // 'Msg': 'No separation or unit operation in between'
    'Msg': 'The attempted stream connection is currently not supported (ref: 6b). Pease contact Veolia for assistance.'
  },
  {
    'source': 'NF',
    'sourcePort': 'Product',
    'Destination': 'Chemical_Dosing',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    // 'Msg': 'No separation or unit operation in between'
    'Msg': 'The attempted stream connection is currently not supported (ref: 7a). Pease contact Veolia for assistance.'
  },
  {
    'source': 'NF',
    'sourcePort': 'Waste',
    'Destination': 'Chemical_Dosing',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    // 'Msg': 'No separation or unit operation in between'
    'Msg': 'The attempted stream connection is currently not supported (ref: 7b). Pease contact Veolia for assistance.'
  },
  {
    'source': 'NF',
    'sourcePort': 'Product',
    'Destination': 'Stripper',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    // 'Msg': 'No separation or unit operation in between'
    'Msg': 'The attempted stream connection is currently not supported (ref: 7c). Pease contact Veolia for assistance.'
  },
  {
    'source': 'NF',
    'sourcePort': 'Waste',
    'Destination': 'Stripper',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    // 'Msg': 'No separation or unit operation in between'
    'Msg': 'The attempted stream connection is currently not supported (ref: 7d). Pease contact Veolia for assistance.'
  },
  {
    'source': 'NF_HP',
    'sourcePort': 'Product',
    'Destination': 'Chemical_Dosing',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    // 'Msg': 'No separation or unit operation in between'
    'Msg': 'The attempted stream connection is currently not supported (ref: 8a). Pease contact Veolia for assistance.'
  },
  {
    'source': 'NF_HP',
    'sourcePort': 'Waste',
    'Destination': 'Chemical_Dosing',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    // 'Msg': 'No separation or unit operation in between'
    'Msg': 'The attempted stream connection is currently not supported (ref: 8b). Pease contact Veolia for assistance.'
  },
  {
    'source': 'NF_HP',
    'sourcePort': 'Product',
    'Destination': 'Stripper',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    // 'Msg': 'No separation or unit operation in between'
    'Msg': 'The attempted stream connection is currently not supported (ref: 8c). Pease contact Veolia for assistance.'
  },
  {
    'source': 'NF_HP',
    'sourcePort': 'Waste',
    'Destination': 'Stripper',
    'targetPort': 'Feed',
    'Immediate': 'invalid',
    'N-th Degree': '',
    // 'Msg': 'No separation or unit operation in between'
    'Msg': 'The attempted stream connection is currently not supported (ref: 8d). Pease contact Veolia for assistance.'
  }

];
export const handleValue = {
  'Feed': 'a',
  'Product': 'c',
  'Waste': 'd',
  'Electrode Bleed': 'e',
  'Concentrate Bleed': 'f'
};
export const uniqueValue = {
  'Feed': ['feed'],
  'Product': ['product'],
  'RO': ['ro'],
  'RO_HP': ['roPump', 'hppump'],
  'Waste': ['wasteout'],
  'EDI': ['edi'],
  'Stripper': ['stripper'],
  'ProductOut': ['product'],
  'Chemical_Dosing': ['chemicaldosing'],
  'NF': ['nf'],
  'NF_HP': ['nfPump', 'nfhppump']
};
export default invalidConnection;